import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const MHistoryModal = ({ show, onHide, match }) => {
  const [showUserId, setShowUserId] = useState(false);
  const [copiedUserId, setCopiedUserId] = useState(null); // track last copied

  if (!match) return null;

  const getScore = () => {
    const team1 = match.teams.team_1?.filter(m => m.score)?.length || 0;
    const team2 = match.teams.team_2?.filter(m => m.score)?.length || 0;
    return `${team1}:${team2}`;
  };

  const toggleUserId = () => setShowUserId(prev => !prev);

  const copyToClipboard = (userId) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(userId)
        .then(() => {
          setCopiedUserId(userId);
          setTimeout(() => setCopiedUserId(null), 1500);
        })
        .catch((err) => {
          console.error('Failed to copy:', err);
        });
    } else {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = userId;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        setCopiedUserId(userId);
        setTimeout(() => setCopiedUserId(null), 1500);
      } catch (err) {
        console.error('Fallback copy failed:', err);
      }
      document.body.removeChild(textarea);
    }
  };


  const renderPlayers = (team) =>
    team?.map((player) => (
      <li key={player.user_id} className="list-group-item bg-transparent border-0 py-1 d-flex justify-content-between align-items-center">
        <span>
          {player.full_name}
          {showUserId && ` (${player.user_id})`}
        </span>
        {showUserId && (
          <Button
            size="sm"
            variant="outline-light"
            onClick={(e) => {
              e.stopPropagation(); // prevent modal row click
              copyToClipboard(player.user_id);
            }}
          >
            {copiedUserId === player.user_id ? 'Copied!' : 'Copy'}
          </Button>
        )}
      </li>
    )) || [];

  const score = getScore();

  return (
    <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
      <Modal.Header
        closeButton
        style={{
          background: '#fff',
          borderBottom: '1px solid #ccc',
          color: '#000',
        }}
      >
        <Modal.Title>
          {match.sport_name}: {match.match_type} ({match.player})
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          background: '#fff',
          color: '#000',
          overflow: 'hidden',
        }}
      >
        <div className="row mb-3">
          <div className="col-md-6">
            <p><strong>Date:</strong> {new Date(match.date).toLocaleDateString()}</p>
          </div>
          <div className="col-md-6">
            <p><strong>Score:</strong> {score}</p>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-12">
            <p><strong>Name of Sport:</strong> {match.sport_name}</p>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-12">
            <p><strong>Match Type:</strong> {match.match_type} | {match.player}</p>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-12">
            <p><strong>Is Counted:</strong> {match.is_counted ? 'Yes' : 'No'}</p>
          </div>
        </div>

        <div className="mb-3">
          <Button variant="secondary" size="sm" onClick={toggleUserId}>
            {showUserId ? 'Hide User IDs' : 'Show User IDs'}
          </Button>
        </div>

        <div className="row">
          <div className="col-12">
            <p><strong>Players:</strong></p>
            <div className="row">
              <div className="col-md-6">
                <ul className="list-group list-group-flush border rounded p-2" style={{ backgroundColor: '#fff', color: '#000' }}>
                  {renderPlayers(match.teams.team_1)}
                </ul>
              </div>
              <div className="col-md-6 mt-3 mt-md-0">
                <ul className="list-group list-group-flush border rounded p-2" style={{ backgroundColor: '#fff', color: '#000' }}>
                  {renderPlayers(match.teams.team_2)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer
        style={{
          background: '#fff',
          borderTop: '1px solid #ccc',
        }}
      >
        <Button variant="dark" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MHistoryModal;
